import jsPDF from "jspdf";
import "jspdf-autotable";
import { MPlus_Encoded_Base64 } from "./mplus-encoded-base64.js";
import moment from "moment";

/**
 * @param busInfoList バスの情報リスト
 */
export async function createBusTablePdf(busInfoList) {
  // ----- PDF作成処理 ----- //
  const doc = new jsPDF({ orientation: "landscape" });

  // ページ番号
  let creatingPageNo = 1;

  // pdfのタイトル（タブに表示されるやつ）
  doc.setProperties({
    title: "バス車両情報印刷用"
  });

  // フォントデータの適応
  doc.addFileToVFS("mplus.ttf", MPlus_Encoded_Base64);
  doc.addFont("mplus.ttf", "mplus", "normal");
  doc.setFont("mplus", "normal");

  // テーブルのフォントサイズの設定
  doc.setFontSize(12);
  doc.text("バス車両一覧", 15, 25);

  // 一覧に表示するデータを15件ごとに分ける
  for (let i = 0; i < busInfoList.length; i += 15) {
    const BUS_INFO = busInfoList.slice(i, i + 15);

    // ページ目追加
    if (creatingPageNo != 1) {
      doc.addPage("a4");
    }

    //一覧で選択した行からデータを取得し、PDFの一覧の列の順序に合わせてSORTする
    const ARR_COL = BUS_INFO.map(row => {
      var col = [];
      for (var key in row) {
        switch (key) {
          case "vehicle_number":
            col[0] = row[key];
            break;
          case "vehicle_operator_name":
            col[1] = row[key];
            break;
          case "vehicle_limit":
            col[2] = row[key];
            break;
          case "created_date":
            col[3] = moment(row[key]).format("YYYY/MM/DD");
            break;
          default:
            break;
        }
      }
      return col;
    });

    // PDFのテーブルの作成
    doc.autoTable({
      theme: "plain",
      startY: 35,
      // ヘッダーの設定(themeのデフォルトの値のため設定)
      headStyles: {
        lineWidth: 0.2,
        lineColor: [0, 0, 0] // RGB
      },
      // ボディの設定(themeのデフォルトの値のため設定)
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: [0, 0, 0]
      },
      styles: {
        font: "mplus",
        fontStyle: "normal",
        fontSize: 10,
        minCellHeight: 7.5,
        valign: "middle"
      },
      head: [["車番", "バス会社名", "乗車可能人数", "QRコード取得日"]],
      // カラムの幅一つを'auto'にしなければconsole.error()が表示される
      columnStyles: {
        0: { cellWidth: 85 },
        1: { cellWidth: 120 },
        2: { cellWidth: 30 },
        3: { cellWidth: "auto" }
      },
      body: ARR_COL
    });

    // ページ追加
    creatingPageNo++;
  }
  // 新しいTabでPDFを表示
  window.open(doc.output("bloburl"));
}
